import { Box, Container } from '@mui/material';

function AuthLayout({ children }) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'grey.100',
      }}
    >
      <Container maxWidth="sm">{children}</Container>
    </Box>
  );
}

export default AuthLayout;
